import { render, staticRenderFns } from "./Basic_info.vue?vue&type=template&id=f278f32e&scoped=true&"
import script from "./Basic_info.vue?vue&type=script&lang=js&"
export * from "./Basic_info.vue?vue&type=script&lang=js&"
import style0 from "./Basic_info.vue?vue&type=style&index=0&id=f278f32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278f32e",
  null
  
)

export default component.exports